import React, {useEffect, useState} from "react";
import {useTheme} from "styled-components";
import {ContentTop16, FlexColumnCentered} from "../../../../components/ui/Content";
import {Body1, Caption2PointerLink, FormTitle, RecoveryEmailInfo} from "../../../../components/Font";
import {useTranslation} from "react-i18next";
import {InputElement} from "../../../../ui/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import moment from "moment";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../../ui/Loader/MiniLoader";
import {RecoveryInputContainer, RegisterInputContainer} from "../../../../components/ui/InputSearch";
import { RepeatCode, resetRetryAfter, setChangeDataModalSuccess, setSmsPending} from "../api/slice";
import { cleanErrorEnter, ConfirmCode } from "../UserInfo/slice";

export const ConfirmCodeForm = () => {

    const Theme = useTheme()
    const [countdown, setCountdown] = useState(0)
    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const [code, setCode] = useState('')
    const {
        changeDataModal,
        smsPending,
    } = useAppSelector(state => state.account)

    const {setSmsPend,error,setChangeSuccess} = useAppSelector(state => state.user)

    const {dataForChange} = changeDataModal

    useEffect(() => {
        const input = document.querySelector('.registerSMSInput') as HTMLInputElement
        if (input) {
            input.focus()
        }
    }, [])
    useEffect(() => {
        if (dataForChange?.retry_after) {
            setCode('')
            setCountdown(dataForChange.retry_after)
        }
    }, [dataForChange?.retry_after])

    useEffect(() => {
        setSmsPend ? setSmsPending(true) : setSmsPending(false)
    }, [setSmsPend])

    useEffect(() => {
        const count = () => {
            if (countdown > 0) {
                setCountdown(countdown - 1)
            } else {
                dispatch(resetRetryAfter())
            }
        }
        const timeout = setTimeout(count, 1000)
        return () => clearTimeout(timeout)
    }, [countdown])

    const submit = () => {
        if (dataForChange?.change_id) {
            dispatch(ConfirmCode({
                change_id: dataForChange.change_id,
                code: code
            }))
        }
    }

    useEffect(() => {
        setChangeSuccess && dispatch(setChangeDataModalSuccess(true))
    }, [setChangeSuccess])
    
    useEffect(() => {
        if (code && code.length === 6) {
            submit()
        }
    }, [code])

    return <>
        <FlexColumnCentered style={{width: '100%', marginTop: '10px'}}>
            <FormTitle>Подтвердите e-mail</FormTitle>
            {dataForChange?.data && <RecoveryEmailInfo style={{textAlign: 'center', width: '270px'}}>
                Отправили письмо c кодом подтверждения на {dataForChange.data}
            </RecoveryEmailInfo>}
        </FlexColumnCentered>
        <RegisterInputContainer style={{marginTop: '28px'}}>
            <RecoveryInputContainer>
                <InputElement
                    className={'registerSMSInput'}
                    format={'###-###'}
                    error={error['code']}
                    mask={'_'}
                    value={code}
                    onChange={value => {
                        setCode(value)
                        if (error['code']) {
                            dispatch(cleanErrorEnter('code'))
                        }
                    }}
                    onKeyDown={(key) => {
                        if (key === 'Enter' && code.length > 0) {
                            submit()
                        }
                    }} placeholder={'Код из письма'}/>
            </RecoveryInputContainer>
        </RegisterInputContainer>
        {countdown <= 0
            ? <>{smsPending
                ? <LoaderContainer style={{marginTop: '8px'}}>
                    <MiniLoader color={Theme.color.indicator} size={LoaderEnum.small}/>
                </LoaderContainer>
                :
                <Caption2PointerLink style={{width: '100%', textAlign: 'start', marginTop: '8px'}} onClick={() => {
                    if (dataForChange?.change_id) {
                        dispatch(RepeatCode({change_id: dataForChange.change_id}))
                    }
                }}>
                    {t('auth.retryCode')}
                </Caption2PointerLink>}</>
            : <ContentTop16>
                <Body1 color={Theme.color.secondary}>
                    {t('auth.retryCodeAfter')}{moment.utc(countdown * 1000).format('mm:ss')}
                </Body1>
            </ContentTop16>}
    </>
}